import { render, staticRenderFns } from "./TopPerformedIb.vue?vue&type=template&id=202d1b2a"
import script from "./TopPerformedIb.vue?vue&type=script&lang=js"
export * from "./TopPerformedIb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports